




















import { Component, Vue } from "vue-property-decorator";
import { NotificationChannelCodes } from "@/data/enums/notifications";
import { TemplateTypes } from "@/data/enums/templates";
import { AdminRoutes } from "@/data/enums/router";

@Component({
  components: {
    "templates-provider": () =>
      import("@/components/app/global/templates/templatesProvider.vue"),
    "templates-notifications-table-view": () =>
      import(
        "@/components/app/global/templates/notifications/templatesNotificationsTableView.vue"
      )
  }
})
export default class AdminEmailTemplatesTable extends Vue {
  public channelCode = NotificationChannelCodes.EMAIL;
  public templateType = TemplateTypes.NOTIFICATION;

  public get cta() {
    return this.$userCan("create_template")
      ? this.$t("_action.create_object", {
          object: (this.$t("_.template") as string).toLowerCase()
        })
      : null;
  }

  public addTemplate() {
    this.$router.push({
      name: AdminRoutes.EMAIL_TEMPLATE_ADD,
      params: {
        channelCode: this.channelCode
      }
    });
  }
}
